import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedTime } from 'react-intl';

import ThumbnailPreviewCertificateDownload from './ThumbnailPreviewCertificateDownload';
import { FormattedMessageWrappedInSpan } from '../../misc';

import SyncProblemRoundedIcon from '@material-ui/icons/SyncProblemRounded';

const ThumbnailPreviewAccountDetails = props => {
  const {
    photoSgId,
    photoNodeId,
    shotDate,
    originalUrl,
    socialMediaUrl,
    startNumbers,
    restartState,
    uploadRestarted,
    onRequestHighResolutionPhoto,
    isFaceSearchEvent,
    hasCertificates,
    eventSgId
  } = props;

  return (
    <div className="thumbnail-preview-details">
      <div className="row">
        <div className="col-xs-16 col-sm-6">
          <div className="thumbnail-preview-photo-number">
            <span>{photoSgId}</span>
          </div>
          {shotDate && (
            <div className="thumbnail-preview-time">
              <FormattedTime
                value={new Date(shotDate)}
                timeZone="UTC"
                hour="2-digit"
                minute="2-digit"
                second="2-digit"
              />
            </div>
          )}
        </div>
        <div className="thumbnail-preview-account-event-actions col-xs-16 col-sm-10">
          {originalUrl && (
            <a href={originalUrl} download>
              <button className="primary">
                <FormattedMessageWrappedInSpan
                  id="thumbnailPreviewAccountDetails.actions.downloadHighResolution"
                  defaultMessage="Download high resolution"
                />
              </button>
            </a>
          )}
          {!originalUrl &&
            (restartState == 'can_restart') &&
            !uploadRestarted && (
              <button className="secondary" onClick={onRequestHighResolutionPhoto}>
                <FormattedMessageWrappedInSpan
                  id="accountEventPage.requestHighResolution"
                  defaultMessage="Request high resolution"
                />
              </button>
            )}
           
          {socialMediaUrl && (
            <a href={socialMediaUrl} download>
              <button className="primary">
                <FormattedMessageWrappedInSpan
                  id="thumbnailPreviewAccountDetails.actions.downloadSocialMediaResolution"
                  defaultMessage="Download Social Media Resolution"
                />
              </button>
            </a>
          )}
          {hasCertificates && originalUrl && (
            <ThumbnailPreviewCertificateDownload
              photoNodeId={photoNodeId}
              startNumbers={startNumbers}
              isFaceSearchEvent={isFaceSearchEvent}
              eventSgId={eventSgId}
            />
          )}
           {!originalUrl &&
            (restartState == 'processing') && (
              <span className="thumbnail-preview-info-about-processing">
                <SyncProblemRoundedIcon />
                <FormattedMessageWrappedInSpan
                  id="thumbnailPreviewAccountDetails.highResolutionsailableSoon"
                  defaultMessage="This photo will be available in high resolution soon. Then you will have additional actions available here."
                />
              </span>
            )}
        </div>
      </div>
    </div>
  );
};

ThumbnailPreviewAccountDetails.propTypes = {
  photoSgId: PropTypes.number,
  photoNodeId: PropTypes.string,
  shotDate: PropTypes.string,
  socialMediaUrl: PropTypes.string,
  originalUrl: PropTypes.string,
  restartState: PropTypes.string,
  uploadRestarted: PropTypes.bool,
  startNumbers: PropTypes.array,
  onRequestHighResolutionPhoto: PropTypes.func,
  isFaceSearchEvent: PropTypes.bool,
  hasCertificates: PropTypes.bool,
  eventSgId: PropTypes.number,
};

export default ThumbnailPreviewAccountDetails;
